import { css } from '@emotion/react';
import theme from 'shared/styles/themes';

export default css({
  '.banner-logo-form': {
    '&__submit-btn': {
      marginTop: theme.space[4],
    },
  },
});
